// Types
import {contractDateTime} from '@drivesally/sally-fn/lib/types';

export default ({transaction: {date_created = ''} = {}} = {}) =>
  contractDateTime(date_created).format();
